import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Client } from '../../../models/clients/client';
import { TableColumn } from '../../../models/tables/TableColumn';
import { ClientService } from '../../../services/client.service';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';
import { PageOption } from '../../../models/common/pageOption';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ClientFilter } from '../../../models/clients/clientFilter';
import { ClientColumns } from '../../../contants/columns/columns.client.list';
import { CommonService } from '../../../services/common.service';
import { PARAMS } from '../../../contants/PARAMS';

@Component({
	selector: 'app-client-list',
	templateUrl: './client-list.component.html',
	styleUrls: ['./client-list.component.css']
})
export class ClientListComponent implements OnInit {

	pageOption: PageOption<ClientFilter> = new PageOption();
	formPath: string = APP_ROUTES.clientForm;
	clientEditBackup: Client;

	clients: Client[] = [];
	tableColumns: TableColumn[] = ClientColumns;

	constructor(
		private _clientService: ClientService,
		private _alertService: AlertService,
		private _parameterService: ParameterService,
		private _commonService: CommonService
	) { }

	ngOnInit() {
		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.CLIENT_TABLE_DEFAULT_COLUMNS, 3600).subscribe(
			result => {
				if (result.length != undefined) {
					this.tableColumns = result.length == 0 ? this.tableColumns : result;
				}
				else {
					console.log('Invalid response from server, will use default column settings instead.')
				}
			}
		);

		this._parameterService.getCachedParameter<number>(PARAMS.CLIENT_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
			value => {
				value = Number(value);
				this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;				
				this.pageOption.pageNumber = 1;

				this.fetchData();
			}
		);
	}

	fetchData(){
		this._clientService.getClientsList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let startIndex = ((result.pageNumber - 1) * this.pageOption.pageSize);
					this._commonService.insertAt(this.clients, startIndex, result.data);
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	onSave(index: number) {
		let client = this.clients[index];
		if (!this.validateClient(client)) {
			this._alertService.showError('client should have a name.')
		}

		if (client.id == undefined || client.id == 0) {
			this.createClient(client);
		}
		else {
			this.updateClient(index, client);
		}
	}

	onAdd(event) {
		this.clients.push(new Client());
	}

	onEditBegin(index: number) {
		this.clientEditBackup = this._clientService.copy(this.clients[index]);
	}

	onEditCancel(index: number) {
		if (this.clientEditBackup == null || index < 0) {
			return;
		}
		this.clients[index] = this.clientEditBackup;
	}

	private createClient(newClient: Client) {
		this._clientService.addClient(newClient).subscribe(result => {
			if (result.object != undefined) {
				this._alertService.showSuccess('Client registered.')
				this.clients[this.clients.length - 1] = result.object;
				this.clientEditBackup = null;
			}
			else {
				this.clients[this.clients.length - 1] = new Client();
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateClient(index: number, existingClient: Client) {
		this._clientService.updateClient(existingClient).subscribe(result => {
			if (result.object == undefined) {
				this.clients[index] = this.clientEditBackup;
				this._alertService.displayErrorResult(result.errorCollection);
			}
			else {
				this._alertService.showSuccess('Client data updated.');
				this.clientEditBackup = null;
			}
		});
	}

	private validateClient(client: Client): boolean {
		let form = new FormGroup({
			name: new FormControl(client.name, [
				Validators.required,
				Validators.maxLength(50)
			]),
			date: new FormControl(client.dateAccredited, [
				Validators.required
			])
		});

		return form.valid;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/clients/client-list/client-list.component.ts